<template>
    <div>
        <div class="flex_box">
            <el-form :inline="true" :model="seachForm" class="demo-form-inline" label-width="80px" size="mini" >
                <el-form-item label="描述">
                    <el-input v-model="seachForm.description"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" plain @click="getTable">刷新</el-button>
                    <el-button type="success" plain @click="addFile">新增</el-button>
                    
                </el-form-item>
            </el-form>
            <div style="flex: 1;">
                <!-- 表格 -->
                <el-table :data="tableData" style="width: 100%"  height="100%" :header-cell-style="{'text-align':'center'}" size="mini">
                    <el-table-column type="index" width="50"></el-table-column>
                    <el-table-column prop="description" label="描述" align="center"  > </el-table-column>
                    <el-table-column prop="month" label="日期" align="center" > </el-table-column>
                    <el-table-column prop="createMan" label="创建人" align="center" > </el-table-column>
                    <el-table-column label="操作" width="180"> 
                        <template slot-scope="scope">
                            <el-button size="mini" type="text" @click="UploadFile(scope.row)">上传文件</el-button>
                            <el-button size="mini" type="text" @click="filesList( scope.row)">查看文件</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!--新增弹窗 -->
        <el-dialog title="新增" :visible.sync="addCode"  width="60%" :before-close="handleCloseAdd">
            <el-form ref="addForm" :model="addForm" label-width="80px" :rules="addrules">
                <el-form-item label="描述" prop="description">
                    <el-input v-model="addForm.description"></el-input>
                </el-form-item>
                <el-form-item label="日期" prop="month">
                    <el-input v-model="addForm.month"></el-input>
                </el-form-item>
                
            </el-form>
             <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseAdd">取 消</el-button>
                <el-button type="primary" @click="sureAdd('addForm')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 上传文件弹窗 -->
        <el-dialog title="上传文件" :visible.sync="uploadFileCode"  width="60%" :before-close="handleCloseUpload">
            <el-upload class="upload-demo" :action="uploadURL" :file-list="uploadFileList" :auto-upload="false"
                    :on-change="handleChange" :on-remove="handleRemove" multiple>
                 <el-button slot="trigger" size="small" type="primary" plain style="margin-right: 10px;">选择文件</el-button>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseUpload">取 消</el-button>
                <el-button type="primary" @click="sureUploadFile">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 查看上传文件弹窗 -->
        <el-dialog title="查看文件列表" :visible.sync="viewFileCode"  width="60%" :before-close="handleCloseView">
            <el-table ref="filesTable" height="600px" :data="viewFileList" highlight-current-row  style="width: 100%" size="mini">
                <el-table-column type="index" width="50"> </el-table-column>
                <el-table-column prop="fileName" label="文件列表"> 
                    <template slot-scope="scope">
                        <el-link  type="primary" @click="downloadFile(scope.row)">{{ scope.row.fileName }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="createMan" label="上传人">  </el-table-column>
                <el-table-column label="操作" align="center" width="80"> 
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.createMan === userName" @click="delFile(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>
<script>

export default {
    //组件创建
    created() {
    },
    data() {
        return {
            fileID:{}, // 文件详情
            // 当前用户名
            userName: localStorage.getItem('name'),
            seachForm:{
                description:''
            },
            uploadURL:process.env.VUE_APP_BASE_API + '/cms/files/uploadFiles', // 文件上传URL
            addCode: false,// 新增弹窗
            addForm:{
                month:'',
                description:'',
            }, // 新增表单
            tableData:[], // 列表数据
            uploadFileCode:false, // 上传文件弹窗
            uploadFileList:[], // 上传文件列表
            fileId:'', // 上传文件id
            viewFileCode:false, // 查看文件弹窗
            viewFileList:[], // 查看上传文件列表
            addrules:{
                month:[
                    {required: true, message: '请输入日期', trigger: 'blur'}
                ],
                description:[
                    {required: true, message: '请输入描述', trigger: 'blur'}
                ],
            }
        }
    },
    mounted() {
        this.getTable()
    },
    methods: {
        // 查询列表
        getTable() { 
            this.$api.getCmsBill(  ).then(res =>{
                this.tableData = res
            })
        },
        // 新增弹窗
        addFile(){
            this.addCode = true
            this.addForm = {}
        },
        // 新增保存
        sureAdd(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$api.insCmsBill( this.addForm ).then(res =>{
                        this.$message({
                            message: '新增日期明细成功',
                            type: 'success'
                        });
                        this.getTable()
                        this.handleCloseAdd()
                    })
                } else {
                    return false;
                }
            });
        },
        // 新增关闭弹窗
        handleCloseAdd(){
            this.addCode = false              
            this.$refs.addForm.resetFields();

        },
        // 上传文件
        UploadFile(data) {
            // 获取上传文件id
            this.fileId = data.id
            this.uploadFileCode = true
        },
        //  上传文件
        sureUploadFile(){
            if(this.uploadFileList.length == 0){
                this.$message({
                    message: '请选择文件',
                    type: 'warning'
                });
                return false
            }
            const formData = new FormData();
            this.uploadFileList.forEach(item => {
                formData.append('files', item.raw);
            });
            this.$api.uploadFiles(this.fileId, formData ).then(res =>{
                this.$message({
                    message: '上传成功',
                    type: 'success'
                });
                this.handleCloseUpload()
                // 获取已上传的文件列表
                this.getTable()
            })
        },
        // 关闭上传文件弹窗
        handleCloseUpload(){
            this.uploadFileCode = false
            this.uploadFileList = []
            this.fileId = ''
        },
        // 文件上传时勾子-
        handleChange(file, fileList){
            this.uploadFileList = fileList
        },
        // 移除文件勾子
        handleRemove(file, fileList) {
            this.uploadFileList = fileList
        },
        // 查看上传列表
        filesList(data){
            this.fileID = data
            this.$api.getFiles( data.id ).then(res =>{
                this.viewFileList = res
                this.viewFileCode = true
            })
        },
        // 关闭查看文件列表弹窗
        handleCloseView(){
            this.viewFileCode = false
            this.viewFileList = []  
            this.fileID = {}
        },
        // 预览文件
        downloadFile(data){
            const params = {
                path: '/preview',
                query: {
                    annexUrl: data.filePath,
                    annexName: data.fileName,
                    annexUser:  data.createMan,
                    id:data.id
                }
            }
            var childWindow = window.open(this.$router.resolve(params).href, '_blank') // 这个就是打开新链接的方式
            var loop = setInterval(() => {
                if (childWindow.closed) {  // 检测子窗口是否关闭
                    clearInterval(loop); // 停止定时器
                    // 子窗口关闭后父页面刷新
                    this.getTable()
                }
            }, 100);
        },
        // 删除文件
        delFile(data){
            this.$confirm('是否确认删除文件?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.deleteFileBy( data.id ).then(res =>{
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                this.filesList(this.fileID)
                })
            }).catch(() => {
            });
        }
    }
}
</script>


<style lang="css" scoped>
.el-table {
    margin-top: -10px;
}
.flex_box{
    display: flex;
    flex-direction: column;
    height: calc(100vh - 85px);
}
</style>